"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AUTH_TOKEN_KEY = "authorizationToken";
var AuthTokenRepository = (function () {
    function AuthTokenRepository() {
    }
    AuthTokenRepository.get = function () {
        var tokenJSON = window.localStorage.getItem(AUTH_TOKEN_KEY);
        if (tokenJSON === null) {
            return null;
        }
        else {
            return JSON.parse(tokenJSON);
        }
    };
    AuthTokenRepository.set = function (authToken) {
        window.localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(authToken));
    };
    return AuthTokenRepository;
}());
exports.default = AuthTokenRepository;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-token-lib/dist/business/auth-token-repository.js
// module id = 114
// module chunks = 0